import { Form } from 'react-bootstrap';

export default function ErrorMessage({ error, touched, className = '' }) {
  return (
    <>
      {error && touched && (
        <Form.Control.Feedback
          className={`d-block px-3 ${className}`}
          type="invalid"
        >
          {error}
        </Form.Control.Feedback>
      )}
    </>
  );
}
